export const RESET_STATES_ACTION_NAME = 'core/reset_states';
